var base = require('kiosk/metrics');

Vue.component('spark-kiosk-metrics', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/kiosk/metrics.js